import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { addTileLayer, getAdress, validateIp } from "./helpers";
import icon from "../images/icon-location.svg";

const ipInput = document.querySelector(".search-bar__input");
const btn = document.querySelector(".search-bar__btn");
const ipInfo = document.getElementById("ip");
const locationInfo = document.getElementById("location");
const timezoneInfo = document.getElementById("timezone");
const ispInfo = document.getElementById("isp");

btn.addEventListener("click", getData);
ipInput.addEventListener("keydown", handleKey);
ipInfo.innerText = "2.63.137.255";
locationInfo.innerHTML = "RU Moscow";
timezoneInfo.innerText = "UTC Europe/Moscow";
ispInfo.innerText = "Rostelecom";

const mapArea = document.querySelector(".map");
const marker = L.icon({
  iconUrl: icon,
  iconSize: [30, 40],
});

var map = L.map(mapArea).setView([55.7483, 37.6171], 16);

addTileLayer(map);
L.marker([55.7483, 37.6171], { icon: marker }).addTo(map);

function getData() {
  if (validateIp(ipInput.value)) {
    getAdress(ipInput.value).then(setInfo);
  }
}

function handleKey(e) {
  if (e.key === "Enter") {
    getData();
  }
}

function setInfo(mapData) {
  const { latitude, longitude, ip, country, region, timezone, org } = mapData;
  if( latitude !== null) {
    ipInfo.innerText = ip;
    locationInfo.innerHTML = country + " " + region;
    timezoneInfo.innerText = timezone;
    ispInfo.innerText = org;
  
    map.setView([latitude, longitude]);
    // map.setLatLng([latitude, longitude])
    L.marker([latitude, longitude], { icon: marker }).addTo(map);
  } else {
    ipInfo.innerText = ip;
    locationInfo.innerHTML = country + " " + region;
    timezoneInfo.innerText = timezone;
    ispInfo.innerText = org;

    map.setView([75, 60]);
    L.marker([75, 60], { icon: marker }).addTo(map);

    alert ('По данному запросу нету координат');
  }

}
